import Stack from "@mui/material/Stack";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import UpdateProductForm from "../../components/forms/UpdateProductForm";
import { getCategories } from "../../feature/category/categorySlice";
import { getProductDetails } from "../../feature/products/updateProductSlice";

export default function EditProduct() {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProductDetails(id));
    dispatch(getCategories());
  }, [dispatch, id]);

  return (
    <Stack direction='column' spacing={2}>
      <UpdateProductForm />
    </Stack>
  );
}
